import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import axiosInstance from '../axiosConfig';

const DiscountManagement = () => {
  const [discount, setDiscount] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  const [alert, setAlert] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDiscount = async () => {
      try {
        const response = await axiosInstance.get('/admin/discount');
        if (response.status === 200) {
          setDiscount(response.data.discount > 0 ? response.data.discount * 100 : '');
          setExpirationDate(response.data.expirationDate ? response.data.expirationDate.split('T')[0] : '');
        }
      } catch (error) {
        console.error('Fehler beim Abrufen des Rabatts:', error);
      }
    };
    fetchDiscount();
  }, []);

  const handleSaveDiscount = async () => {
    setError(null);

    // 1️⃣ Rabatt muss eingegeben sein (auch 0 ist erlaubt)
    if (discount === '') {
      setError('Bitte geben Sie einen Rabattwert ein oder setzen Sie 0, um ihn zu deaktivieren.');
      return;
    }

    // 2️⃣ Rabatt in das richtige Format umwandeln
    const discountValue = parseFloat(discount) / 100;

    if (isNaN(discountValue) || discountValue < 0 || discountValue > 1) {
      setError('Der Rabatt muss zwischen 0% und 100% liegen.');
      return;
    }

    if (discount !== '0' && expirationDate) {
      const today = new Date();
      const selectedDate = new Date(expirationDate);
      if (selectedDate <= today) {
        setError('Das Ablaufdatum muss in der Zukunft liegen.');
        return;
      }
    }

    try {
      await axiosInstance.post('/admin/discount', { discount: discountValue, expirationDate });

      setAlert({ severity: 'success', message: 'Rabatt erfolgreich aktualisiert.' });
    } catch (error) {
      setAlert({ severity: 'error', message: 'Fehler beim Aktualisieren des Rabatts.' });
    }
  };

  return (
    <Box sx={{ padding: '1rem', width: '100%', maxWidth: '400px' }}>
      {alert && <Alert severity={alert.severity} sx={{ mb: 2 }}>{alert.message}</Alert>}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <TextField
        label="Rabatt (%)"
        type="number"
        value={discount}
        onChange={(e) => setDiscount(e.target.value === '' ? '' : parseFloat(e.target.value))}
        inputProps={{ min: 0, max: 100 }}
        sx={{ mb: 2, width: '100%' }}
      />

      <TextField
        label="Ablaufdatum"
        type="date"
        value={expirationDate}
        onChange={(e) => setExpirationDate(e.target.value)}
        sx={{ mb: 2, width: '100%' }}
        InputLabelProps={{ shrink: true }}
        disabled={discount === 0}
      />

      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={handleSaveDiscount}
        sx={{ mt: 2, mb: 2, bgcolor: 'primary.light', '&:hover': { color: '#fff' } }}
        type="button"
      >
        Rabatt speichern
      </Button>
    </Box>
  );
};

export default DiscountManagement;
